import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class GoogleMapsService {
  private pending: Promise<any>;
  constructor(private http: HttpClient) {}
  load(): Promise<any> {
    if (this.pending) return this.pending;
    this.pending = this.start().catch(error => { this.pending = null; throw error; });
    return this.pending;
  }
  private async start(): Promise<any> {
    const config = await this.http.get<{apiKey:string}>(environment.apiHost + '/address/google-config').pipe(timeout(6000)).toPromise();
    if (!config?.apiKey) throw new Error('Address search unavailable');
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const callback = '__churchGoogleMapsReady';
      const globals = window as any;
      let settled = false;
      const finish = (error?: Error) => {
        if (settled) return; settled = true; clearTimeout(timer);
        if (error) { script.remove(); reject(error); }
        else resolve(globals.google.maps);
      };
      globals[callback] = () => finish();
      const timer = window.setTimeout(() => finish(new Error('Address search timed out')), 12000);
      const url = new URL('https://maps.googleapis.com/maps/api/js');
      url.search = new URLSearchParams({key:config.apiKey, v:'weekly', loading:'async', callback}).toString();
      script.src = url.toString(); script.async = true;
      script.onerror = () => finish(new Error('Address search unavailable'));
      document.head.appendChild(script);
    });
  }
}
